(() => {
  'use strict';
  if (window.skDataGuideLoaded) return;
  window.skDataGuideLoaded = true;

  function init(scope) {
    scope.querySelectorAll('[data-skdg-explorer]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const list = root.querySelector('[data-skdg-tabs]');
      const tabs = Array.from(root.querySelectorAll('[data-skdg-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-skdg-panel]'));
      if (!list || !tabs.length || tabs.length !== panels.length) return;
      const select = (selected, focus = false) => {
        tabs.forEach((tab, index) => {
          const active = index === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[index].hidden = !active;
        });
        if (focus) tabs[selected].focus({ preventScroll: true });
      };
      list.setAttribute('role', 'tablist');
      list.hidden = false;
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      root.addEventListener('shopify:block:select', (event) => {
        const index = panels.findIndex((panel) => panel === event.target || panel.contains(event.target));
        if (index >= 0) select(index);
      });
      select(0);
    });
    scope.querySelectorAll('[data-skdg-directory]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const status = root.querySelector('[data-copy-status]');
      root.querySelectorAll('[data-copy]').forEach((button) => {
        if (!navigator.clipboard || !status) return;
        button.hidden = false;
        button.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(button.dataset.copy);
            status.textContent = `${button.dataset.copy}${status.dataset.success}`;
          } catch (_) {
            status.textContent = status.dataset.failure;
          }
        });
      });
    });
    scope.querySelectorAll('[data-skdg-print]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const checks = Array.from(root.querySelectorAll('[data-skdg-check]'));
      const status = root.querySelector('[data-check-status]');
      if (!status || !checks.length) return;
      const update = () => {
        const checked = checks.filter((check) => check.checked).length;
        status.textContent = checked === checks.length
          ? status.dataset.done
          : `${checked} / ${checks.length} ${status.dataset.label}`;
      };
      checks.forEach((check) => check.addEventListener('change', update));
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
